<template>
	<router-link class="card" :to="{ path: competition.content.fullPath }" @click.native="handleCompetitionClick">
		<div class="card__image">
			<CompetitionLogo :competition="competition" />
		</div>
		<p class="card__text">{{ competitionName }}</p>
	</router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ObjectType, SportCompetitionV2 } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import CompetitionLogo from '@/features/sports/components/ui/CompetitionLogo.vue';

const props = defineProps<{
	competition: SportCompetitionV2;
}>();

const competitionName = computed(() => props.competition?.content?.name);

function handleCompetitionClick() {
	const sportContext = new SnowplowSportContext(props.competition.sport, ObjectType.SportCompetition);
	sportContext.competitionId = props.competition.objectId;

	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'competition_clicked', property: 'icon', useLastRoute: true },
		[sportContext]
	);
}
</script>

<style lang="scss" scoped>
@import '~@/styles/sports.scss';
@import '~@/styles/variables.scss';

.card {
	height: 124px;
	width: 124px;
	padding: 24px 8px 16px 8px;
	margin-inline-end: 12px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	background: $card-background-color-light;
	border-radius: 8px;
	overflow: hidden;

	@media (min-width: 550px) {
		height: 146px;
		width: 146px;
		margin-inline-end: 16px;
	}

	&__image {
		display: flex;
		align-items: center;
		justify-content: center;

		overflow: hidden;
		width: 50px;
		height: 50px;
		flex-shrink: 0;
		border-radius: 8px;

		img {
			object-fit: cover;
		}
	}

	&__text {
		width: 100%;
		height: 100%;
		@include typo-sport-small;
		text-align: center;
		max-height: 38px;
		color: $color-neutral-neutral-light;

		// this applies "line-clamp: 2"
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;

		@media (max-width: 550px) {
			margin-top: 10px;
			overflow: visible;
		}
	}
}
</style>
